import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import SellableItemList from "./table/sellable-item-list/SellableItemList"

const SellableItemTable = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <SellableItemList />
      </CustomCard>
    </div>
  )
}

export default SellableItemTable
